import React from 'react';

export default function Button({border, children, disabled, size, styles, type, onClick}) {
  return (
    <div
      className={`${styles} button button__${type} button__${size} button__${border} ${disabled ? 'button__disabled' : ''}`}
      onClick={onClick && onClick}
      disabled={disabled}>
      {children}
    </div>
  )
}
